import React, { ReactNode } from 'react';
import { ApexOptions } from 'apexcharts';
import ReactApexChart from 'react-apexcharts';

interface RequestStatCardProps {
  totalRequest?: number;
  numberOfRequest: string;
  label: string;
  bgColour: string;  
}

const RequestStatCard: React.FC<RequestStatCardProps> = ({totalRequest, numberOfRequest, label, bgColour}) => {

    const valueStyle = `text-right text-title-lg font-bold text-black dark:text-white`
    const requestStyle = `w-8 h-8 rounded-full ${bgColour}`

    const tots = totalRequest;

    return (
        <div className="rounded-sm border border-stroke bg-white py-2 px-4 shadow-default dark:border-strokedark dark:bg-boxdark">
            <div className="flex items-end justify-between">
                <div className={requestStyle}>
                </div>
                <div>
                    <h3 className={valueStyle}>{numberOfRequest} </h3>
                    <div className="text-right font-normal text-slate-500">{label}</div>
                </div>        
            </div>
            
        </div>        
    );
};

export default RequestStatCard;
